import { LingodaLogo } from '@lingoda/logotype';
import { studentSelector } from '@lingoda/students';
import { RouterLink, studentHomePath, teacherBookingPath } from '@lingoda/router';
import { trans } from '@lingoda/i18n';
import { Box, Button, Toolbar } from '@lingoda/ui';
import { useSelector } from '@lingoda/hooks';

interface Props {
    disabledLogo?: boolean;
}

export const LoggedUserHeader = ({ disabledLogo }: Props) => (
    <Toolbar data-testid="logged-header">
        {disabledLogo ? (
            <LingodaLogo white={false} width={100} />
        ) : (
            <RouterLink to={studentHomePath()}>
                <LingodaLogo white={false} width={100} />
            </RouterLink>
        )}
        <Box flexGrow={1} />
        <UserLinks />
    </Toolbar>
);

const UserLinks = () => {
    const student = useSelector(studentSelector);

    return (
        <Button variant="text" href={student ? studentHomePath() : teacherBookingPath()}>
            {trans('navigation.user.my-account', {}, 'public-common')}
        </Button>
    );
};
